export default (initialState = {}) => {
  return () => {
    return {
      account_number: "",
      bank_beneficiary_name: "",
      ifsc_code: "",
      bank_name: "",
      code: "",
      file: null,
      is_primary: false,
      status_cd: "unverified",
      branch_address: "",
      ...initialState,
    };
  };
};
